import React, { ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Card, CardContent, Skeleton, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  ztLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    width: theme.spacing(51),
    height: theme.spacing(15)
  },
  card: {
    width: theme.spacing(51),
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginTop: theme.spacing(3)
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    height: '100vh'
  },
  text: {
    height: theme.spacing(7),
    width: theme.spacing(43),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4)
  },
  closeMessage: {
    height: theme.spacing(5),
    width: theme.spacing(43),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4)
  }
}));

const CollectorAccessDeniedSkeleton = (): ReactElement => {
  const classes = useStyles();

  return (
    <div
      data-testid="collector-error-page-skeleton"
      className={classes.container}
    >
      <div className={classes.ztLogo}>
        <Skeleton
          className={classes.ztLogo}
          data-testid="collector-access-ztLogo-Skeleton"
        />
      </div>
      <br />
      <Card
        className={classes.card}
        data-testid="collector-access-card-skeleton"
      >
        <CardContent>
          <Typography variant="body1">
            <Skeleton
              className={classes.text}
              data-testid="collector-access-text-skeleton"
            />
          </Typography>
          <br />
          <Typography variant="body2">
            <Skeleton
              className={classes.closeMessage}
              data-testid="collector-access-close-window-skeleton"
            />
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default CollectorAccessDeniedSkeleton;
